import React from "react";
import PropTypes from "prop-types";
import Checkbox from '@hig/checkbox';
import styled from "styled-components";
import { Text } from "@dhxete/text";

const CheckboxIP = ({
  label,
  disabled,
  indeterminate,
  onBlur,
  onChange,
  onFocus,
  onMouseDown,
  className,
  checked,
  style,
  description,
  id // adding for automation locators.

}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Checkbox, {
    label: label,
    checked: checked,
    disabled: disabled,
    indeterminate: indeterminate,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onMouseDown: onMouseDown,
    id: id
  }), /*#__PURE__*/React.createElement(Text, style, description));
};

CheckboxIP.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  indeterminate: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.bool,
  onFocus: PropTypes.func,
  onMouseDown: PropTypes.func,
  checked: PropTypes.bool,
  style: PropTypes.object,
  description: PropTypes.string,
  id: PropTypes.string
};
export default styled(CheckboxIP)`
  display: inline-flex;

  > div {
    margin-right: 10px;
    > span {
      ${({
  checked
}) => checked ? `
        background-color: #0696d7;
      ` : `
        background-color: transparent;
      `}
    }
  }
`;